import PageLogin from './views/login.vue'
import pageRed from './views/red/index.vue'

export default {
	routes: [
		{
			// 红包
			path: '/red',
			name: 'red',
			component: pageRed
		},
		{
			path:'/login',
			name:'login',
			component:PageLogin
		},// 兜底路由
		{
			path: '*',
			redirect: { name: 'red' }
		}
	]
}